export class TopicVo {
    public id: number;
    public subjectID: number;
    public topicName: string;
    public blurb:string="";
    public slug:string="";
    public difficulty:number=0;
    //icon is used for language
    public level:number=0;
    public icon:string="";
    public catID:number=0;
    public subCatID:number=0;
    constructor(id: number,subjectID:number, topicName: string,level:number=0) {
        this.id = id;
        this.subjectID = subjectID;
        this.topicName = topicName;
        this.level=level;
    }
}